import { render, staticRenderFns } from "./CustomizePanel.vue?vue&type=template&id=4453540e&scoped=true&"
import script from "./CustomizePanel.vue?vue&type=script&lang=js&"
export * from "./CustomizePanel.vue?vue&type=script&lang=js&"
import style0 from "./CustomizePanel.vue?vue&type=style&index=0&id=4453540e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4453540e",
  null
  
)

export default component.exports